import CopyBlock from './CopyBlock'
export default CopyBlock
